import React, { FC } from "react";
import { Row, Col } from "antd";
import styles from "./service-menu.module.css";
import { ChevronRight, DriveFileRenameOutline } from "@mui/icons-material";
import { Button } from "../button/button";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../routes";

export interface ServiceMenuItem {
  slug: string;
  type: string;
  name: string;
}

export interface ServiceMenuSection {
  title: string;
  linkLabel?: string;
  linkUrl?: string;
  items: ServiceMenuItem[];
  color?: string;
  icon?: React.ComponentType<any>;
}

export interface ServiceMenuProps {
  heading?: string;
  subheading?: string;
  buttonLabel?: string;
  sections?: ServiceMenuSection[];
}

export const ServiceMenu: FC<ServiceMenuProps> = ({
  heading = "Serviços Disponíveis",
  subheading = "Selecione um serviço para obter mais informações",
  buttonLabel = "Acessar todos",
  sections = [],
}) => {
  const history = useHistory();

  const validSections = sections.filter(
    (sec) => sec.items && sec.items.length > 0,
  );
  if (validSections.length === 0) return null;

  const navigateToAll = () => history.push(ROUTES.SERVICE_LIST_PAGE);

  return (
    <div className={styles.serviceMenu}>
      <div className={styles.headerMobile}>
        <div className={styles.headerBar} />
        <div>
          <h2 className={styles.mobileHeading}>{heading}</h2>
          <div className={styles.mobileSubheading}>{subheading}</div>
        </div>
      </div>

      <Row justify="space-between" align="middle" className={styles.headerRow}>
        <Col className={styles.headerCol}>
          <div className={styles.headerTextContainer}>
            <div className={styles.headerBar} />
            <DriveFileRenameOutline className={styles.headerBarIcon} />
          </div>

          <div className={styles.headerText}>
            <h2 className={styles.heading}>{heading}</h2>
            <div className={styles.subheading}>{subheading}</div>
          </div>
        </Col>

        <Col>
          <Button
            onClick={navigateToAll}
            iconComponent={
              <DriveFileRenameOutline className={styles.headerButtonIcon} />
            }
            text={buttonLabel}
            className={styles.headerButton}
          />
        </Col>
      </Row>

      <div className={styles.serviceMenuDivider} />

      <Row gutter={[32, 32]} justify="start" className={styles.cardsRow}>
        {validSections.map((section, idx) => (
          <Col key={`section-${idx}`} xs={24} sm={24} md={8}>
            <div className={styles.card}>
              <div
                className={styles.cardHeader}
                style={{ borderColor: section.color }}
              >
                <span className={styles.cardTitle}>
                  {section.icon ? (
                    <section.icon className={styles.cardHeaderIcon} />
                  ) : (
                    <DriveFileRenameOutline className={styles.cardHeaderIcon} />
                  )}
                  {section.title}
                </span>

                {section.linkLabel && (
                  <a
                    href={section.linkUrl}
                    className={styles.cardLink}
                    onClick={(e) => {
                      e.preventDefault();
                      if (section.linkUrl) history.push(section.linkUrl);
                    }}
                  >
                    {section.linkLabel}
                  </a>
                )}
              </div>

              <ul className={styles.cardList}>
                {section.items.slice(0, 5).map((item, i) => (
                  <li
                    key={`item-${i}`}
                    className={styles.cardListItem}
                    onClick={() =>
                      history.push(
                        `${ROUTES.SERVICE_LIST_PAGE}/${item.slug}`,
                      )
                    }
                  >
                    <div className={styles.leftGroup}>
                      <div className={styles.itemBar} />
                      <div className={styles.leftContent}>
                        <span className={styles.itemType}>{item.type}</span>
                        <span className={styles.itemName}>{item.name}</span>
                      </div>
                    </div>

                    <span className={styles.itemArrow}>
                      <ChevronRight />
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </Col>
        ))}
      </Row>

      <div className={styles.bottomButtonContainer}>
        <Button
          onClick={navigateToAll}
          iconComponent={<ChevronRight />}
          text="Acessar todos serviços"
        />
      </div>
    </div>
  );
};